import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getOrgProfile } from "../../../service/endpoints";

export const getOrgProfileHandler = createAsyncThunk('getOrgProfileHandler', async () => {
    try {
        const response = await getOrgProfile()
        console.log(response.data,'profile')
        return response.data
       

        } catch (error) {
            if (error.response !== undefined) {
                console.log('fail', error)
                throw error.response
            }
            else {
                console.log(error)
                throw error.response
            }
        }
    })


const getOrgProfileSlice = createSlice({
    name: 'getprofile',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(getOrgProfileHandler.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getOrgProfileHandler.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(getOrgProfileHandler.rejected, (state, action) => {
            console.log(action.state)
            state.isError = true;
            console.log(action.payload);

        });
    }

})

export default getOrgProfileSlice.reducer;